import {faBell} from "@fortawesome/pro-light-svg-icons/faBell";
import {faTruckFast} from "@fortawesome/pro-light-svg-icons/faTruckFast";
import {faBalloons} from "@fortawesome/pro-solid-svg-icons/faBalloons";
import {faBird} from "@fortawesome/pro-solid-svg-icons/faBird";
import {faCalendarDays} from "@fortawesome/pro-solid-svg-icons/faCalendarDays";
import {faCircleCheck} from "@fortawesome/pro-solid-svg-icons/faCircleCheck";
import {faCircleInfo} from "@fortawesome/pro-solid-svg-icons/faCircleInfo";
import {faCircleXmark} from "@fortawesome/pro-solid-svg-icons/faCircleXmark";
import {faCreditCard} from "@fortawesome/pro-solid-svg-icons/faCreditCard";
import {faCrown} from "@fortawesome/pro-solid-svg-icons/faCrown";
import {faFlowerTulip} from "@fortawesome/pro-solid-svg-icons/faFlowerTulip";
import {faTreeChristmas} from "@fortawesome/pro-solid-svg-icons/faTreeChristmas";
import {faTriangleExclamation} from "@fortawesome/pro-solid-svg-icons/faTriangleExclamation";
import {faTruck} from "@fortawesome/pro-solid-svg-icons/faTruck";
import {faUmbrellaBeach} from "@fortawesome/pro-solid-svg-icons/faUmbrellaBeach";
import {faVirus} from "@fortawesome/pro-solid-svg-icons/faVirus";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {ClientEventTypes, useClientLimitedEvents} from "@twigsby/client-data";
import {
    BuildEntry,
    Button,
    ButtonSize,
    ColourSolid,
    ContentBlock,
    Directions,
    Drawer, EntryContent,
    FlexAlign,
    FlexGap, GenericLoader, Placement,
    StackHorizontal,
    StackVertical, Tooltip, ToolTipPlacement, useLayout,
    useNotifications, useTranslation
} from "@twigsby/frontend-framework";
import React, {useEffect, useState} from 'react';
import {NavLink} from "react-router-dom";
import {useUKPBAuth} from "../Providers/AuthProvider";
import {useSite} from "../Providers/SiteInterfaceProvider";

const AlertIconMap = {
    'bell': faBell,
    'circle-info': faCircleInfo,
    'triangle-exclamation': faTriangleExclamation,
    'circle-check': faCircleCheck,
    'circle-xmark': faCircleXmark,
    'credit-card': faCreditCard,
    'calendar-days': faCalendarDays,
    'truck': faTruck,
    'tree-christmas': faTreeChristmas,
    'virus': faVirus,
    'bird': faBird,
    'flower-tulip': faFlowerTulip,
    'umbrella-beach': faUmbrellaBeach,
    'crown': faCrown,
    'balloons': faBalloons
}

type MapBannerEventsType = {

}

const MapEventToasts = () => {
    const { t } = useTranslation();
    const { addNotification } = useNotifications();
    const { sidebarOpen, isMedium, isUltraWide } = useLayout();
    const { setServiceManager, AddViewedAlertId, LOCAL_STORAGE_KEYS } = useSite();
    const { error, data, status } = useClientLimitedEvents();
    const [ eventsShown, setEventsShown ] = useState<boolean>(false);
    const [ alertCount, setAlertCount ] = useState<number>(0);

    const HandleAlertDismissed = (id: number) => {
        AddViewedAlertId(id);
        setAlertCount((oldCount) => oldCount - 1);
    };

    const LoopEvents = () => {
        const filteredData : any = data?.filter((item: any) => item.eventTypeId === ClientEventTypes.Service);
        const viewedIds = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.EVENTS) || '[]');

        setAlertCount(filteredData.length);

        for (const item of filteredData) {
            if(!viewedIds.includes(item.id)) {
                addNotification({
                    title: item.metadata.Header,
                    description: item.metadata.Body,
                    icon: faCreditCard,
                    manualClose: true,
                    colour: item.metadata.StatusColour as ColourSolid,
                    removeCallback: () => HandleAlertDismissed(item.id),
                    actionCallback: item.metadata.Link ? () => window.open(item.metadata.Link, '_blank') : undefined,
                    actionLabel: item.metadata.Link ? item.metadata.LinkText || 'Learn More' : undefined
                })
            } else {
                setAlertCount((oldCount) => oldCount - 1);
            }
        }

        setEventsShown(true);
    }

    useEffect(()=>{
        if(data && !eventsShown) {
            LoopEvents();
        }
    }, [data, eventsShown]);

    return (
        <>
            {status === 'loading' ? (
                <div className={'side-navigation-entry'}>
                    <GenericLoader  size={"2x"} />
                </div>
            ) : status === "error" ? (
                <ContentBlock error={true} title={error.name} content={error.message} />
            ) : (

                <Tooltip content={t('notifications.title')} position={ToolTipPlacement.Right} disabled={sidebarOpen || !isMedium || isUltraWide}>
                    <div
                        className={`side-navigation-entry collapsable`}
                        onClick={() => setServiceManager(true)}
                    >
                        <EntryContent title={t('notifications.title')} url={'/'} icon={faBell} badgeCount={alertCount} />
                    </div>
                </Tooltip>
            )}
        </>
    )
}

const MapBannerEvents = (props: MapBannerEventsType) => {
    const { error, data, status } = useClientLimitedEvents();

    return (
        <StackVertical gap={FlexGap.Medium}>
            {status === 'loading' ? (
                <div className={'side-navigation-entry'}>
                    <GenericLoader  size={"2x"} />
                </div>
            ) : status === "error" ? (
                <ContentBlock error={true} title={error.name} content={error.message} />
            ) : (
                <>
                    {data && data.map((item, index) =>
                        <StackHorizontal key={`serviceEvent${index}`}>
                            <div className={`pl-xs pr-xs mr-xs ${item.metadata.StatusColour as ColourSolid}`} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.3em' }}>
                                <FontAwesomeIcon icon={AlertIconMap[item.metadata.Icon]} fixedWidth={true} />
                            </div>
                            <StackVertical align={FlexAlign.Start} gap={FlexGap.ExtraSmall}>
                                <div>
                                    <strong style={{ fontWeight: 800 }}>{item.metadata.Header as string}</strong>
                                    <div>{item.metadata.Body}</div>
                                </div>

                                {item.metadata.Link && (
                                    <Button title={item.metadata.LinkText ?? 'Learn More'} onClick={() => window.open(item.metadata.Link, '_blank')} size={ButtonSize.Small} />
                                )}

                            </StackVertical>
                        </StackHorizontal>
                   )}
                </>
            )}
        </StackVertical>
    )
}

const ServiceAlertManager = () => {
    const { token } = useUKPBAuth();
    const { setServiceManager,  serviceManagerOpen } = useSite();

    return (
        <Drawer title="Notifications" isOpen={serviceManagerOpen} direction={Directions.End} closeCallback={() => setServiceManager(false)}>
            {token && (
                <MapBannerEvents />
            )}
        </Drawer>
    )
}

export { MapEventToasts, MapBannerEvents, ServiceAlertManager }
